import { types } from 'mobx-state-tree';
import Price from './Price';

const QuantityDiscount = types.model('QuantityDiscount', {
  quantity: types.number,
  discount: types.number,
  price: Price
});

export default QuantityDiscount;



// WEBPACK FOOTER //
// ./src/models/QuantityDiscount.js